import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCustomer } from "../contexts/CustomerContext";
import { toast } from "sonner";

export const MobileLoginModal = () => {
  const navigate = useNavigate();
  const {
    showLoginModal,
    sendLoginOtp,
    loginWithOtp,
    hideLogin,
  } = useCustomer();

  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [loadingSend, setLoadingSend] = useState(false);
  const [loadingVerify, setLoadingVerify] = useState(false);

  useEffect(() => {
    if (!showLoginModal) {
      setPhone("");
      setOtp("");
      setOtpSent(false);
      setLoadingSend(false);
      setLoadingVerify(false);
    }
  }, [showLoginModal]);

  if (!showLoginModal) {
    return null;
  }

  const handleSendOtp = async () => {
    if (!/^\d{10}$/.test(phone)) {
      return toast.error("Enter a valid 10-digit phone number.");
    }

    setLoadingSend(true);
    const result = await sendLoginOtp(phone);
    setLoadingSend(false);

    if (result.success) {
      toast.success(result.data.message || "OTP sent. Use 123456 to verify.");
      setOtpSent(true);
    } else {
      toast.error(result.error);
    }
  };

  const handleVerifyOtp = async () => {
    if (!/^\d{10}$/.test(phone)) {
      return toast.error("Enter a valid 10-digit phone number.");
    }
    if (!/^\d{6}$/.test(otp)) {
      return toast.error("Enter the 6-digit OTP.");
    }

    setLoadingVerify(true);
    const result = await loginWithOtp(phone, otp);
    setLoadingVerify(false);

    if (result.success) {
      toast.success("Logged in successfully.");
      if (result.resumedBooking) return;
      const target = sessionStorage.getItem("repairro_booking_return");
      sessionStorage.removeItem("repairro_booking_return");
      navigate(target?.startsWith("/dashboard/bookings/") ? target : "/dashboard");
    } else {
      toast.error(result.error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 animate-in fade-in zoom-in-95">
        <h2 className="text-2xl font-bold text-slate-900 mb-2">Login with mobile number</h2>

        <p className="text-slate-600 text-sm mb-6">
          Enter your registered mobile number to receive a verification OTP.
        </p>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Mobile number</label>
            <input
              type="text"
              inputMode="numeric"
              maxLength={10}
              value={phone}
              onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
              className="w-full border border-slate-200 rounded-xl px-4 py-3 focus:border-[#0369A1] focus:ring-2 focus:ring-[#0369A1]/20"
              placeholder="Enter 10-digit phone"
            />
          </div>

          <button
            onClick={handleSendOtp}
            disabled={loadingSend}
            className="w-full px-4 py-3 bg-[#0369A1] text-white rounded-xl font-semibold hover:bg-[#e65a20] transition"
          >
            {loadingSend ? "Sending OTP..." : otpSent ? "Resend OTP" : "Send OTP"}
          </button>

          {otpSent && (
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">OTP</label>
              <input
                type="text"
                inputMode="numeric"
                maxLength={6}
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                className="w-full border border-slate-200 rounded-xl px-4 py-3 focus:border-[#0369A1] focus:ring-2 focus:ring-[#0369A1]/20"
                placeholder="Enter 6-digit OTP"
              />
            </div>
          )}

          <button
            onClick={handleVerifyOtp}
            disabled={loadingVerify || !otpSent}
            className="w-full px-4 py-3 bg-[#0369A1] text-white rounded-xl font-semibold hover:bg-[#115e54] transition"
          >
            {loadingVerify ? "Verifying..." : "Verify OTP & Login"}
          </button>
        </div>

        <button
          onClick={hideLogin}
          className="w-full mt-6 px-4 py-3 text-slate-600 text-sm rounded-xl border border-slate-200 hover:bg-slate-50 transition"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default MobileLoginModal;
